module.exports = __webpack_public_path__ + "img/soak2.f59cfb1f.gif";